import Vue from "vue";
import App from "./App";

// BootstrapVue add
import BootstrapVue from "bootstrap-vue";
// Router & Store add
import router from "./router";
import store from "./store";
// Multi Language Add
import en from "./locales/en.json";
import es from "./locales/es.json";
import VueI18n from "vue-i18n";
import { firebaseConfig } from "./constants/config";
// Notification Component Add
import Notifications from "./components/Common/Notification";
// Breadcrumb Component Add
import Breadcrumb from "./components/Common/Breadcrumb";
// RefreshButton Component Add
import RefreshButton from "./components/Common/RefreshButton";
// Colxx Component Add
import Colxx from "./components/Common/Colxx";
// Perfect Scrollbar Add
import vuePerfectScrollbar from "vue-perfect-scrollbar";
import contentmenu from "v-contextmenu";
import VueLineClamp from "vue-line-clamp";
import VueScrollTo from "vue-scrollto";
import firebase from "firebase/app";
import "firebase/auth";
import { getCurrentLanguage } from "./utils";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Animate from "animate.css";

//import socketio from 'socket.io';
import VueSocketIO from "vue-socket.io";

import vClickOutside from "v-click-outside";

//export const SocketInstance = socketio('http://34.138.64.224');
//Vue.use(VueSocketIO, SocketInstance)

import VueVirtualScroller from "vue-virtual-scroller";
import { RecycleScroller } from "vue-virtual-scroller";
import VModal from "vue-js-modal";

Vue.use(VueVirtualScroller);

Vue.use(BootstrapVue);
Vue.use(VueI18n);
const messages = { en: en, es: es };
const locale = getCurrentLanguage();

const i18n = new VueI18n({
    locale: locale,
    fallbackLocale: "es",
    messages,
});
Vue.use(Notifications);
Vue.use(require("vue-shortkey"));
Vue.use(contentmenu);
Vue.use(VueScrollTo);
Vue.use(Animate);
Vue.use(VueSweetalert2);
Vue.use(VueLineClamp, {
    importCss: true,
});

import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
Vue.component("RecycleScroller", RecycleScroller);

Vue.component("piaf-breadcrumb", Breadcrumb);
Vue.component("b-refresh-button", RefreshButton);
Vue.component("b-colxx", Colxx);
Vue.component("vue-perfect-scrollbar", vuePerfectScrollbar);

Vue.use(vClickOutside);
Vue.use(VModal, { dynamic: false, injectModalsContainer: true });

firebase.initializeApp(firebaseConfig);
Vue.config.productionTip = true;

export default new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
